/**
 * The electronic invoice (FatturaPA) of the Tesoreria (07/10/2026): the XML
 * taken out of a signed file, and the limit of what is kept. The readable copy
 * is drawn by the AssoSoftware stylesheet in the web app.
 */
/** Largest XML accepted for an invoice: far beyond a real one, well within the API limit. */
export const FATTURA_XML_MAX_LENGTH = 5_000_000;
/**
 * The XML of an electronic invoice from a file: plain XML, or a signed
 * «.xml.p7m» (CAdES), where the XML is inside the binary envelope. Null when
 * no FatturaElettronica is found. Large text nodes of a p7m may be split by
 * the envelope: the readable copy works on the first and complete document.
 */
export function extractFatturaXml(bytes) {
    const text = new TextDecoder('utf-8', { fatal: false }).decode(bytes);
    const start = text.search(/<\?xml|<(?:\w+:)?FatturaElettronica[\s>]/);
    if (start < 0)
        return null;
    const close = /<\/(?:\w+:)?FatturaElettronica>/.exec(text.slice(start));
    if (!close)
        return null;
    const xml = text.slice(start, start + close.index + close[0].length);
    return /<(?:\w+:)?FatturaElettronica[\s>]/.test(xml) ? xml : null;
}
//# sourceMappingURL=fattura-pa.js.map